import { Link } from "gatsby"

import { Img } from "../../../../layout/Img"
import { ProfileLink } from "./ProfileLink"

export const ProfileFixed = ({ profiles }) => {
  if (!profiles || profiles.length === 0) {
    return null
  }

  return (
    <div className="container flex flex-col mx-auto md:w-9/12 ">
      <div className="grid grid-cols-2 gap-6 mx-6 md:grid-cols-4">
        {profiles?.map((item, index) => (
          <Link key={index} to={`/${item.uri}`}>
            <div>
            <Img
                className="w-full aspect-h-60 aspect-w-60"
                image={item.profilePicture[0]}
              />
              <div className="mt-4 cursor-pointer">
                <div className="flex">
                  {item.profileLinks?.map(({ uid, ...rest }) => (
                    <div key={uid} className="mt-2">
                      <ProfileLink
                        customClass="text-secondary mr-2"
                        {...rest}
                      />
                    </div>
                  ))}
                </div>
                <h2 className="mt-2 font-semibold">{item.title}</h2>
                <span className="font-base">{item.profileRole}</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  )
}
